import Product from './product';

moment.updateLocale('es');

class Period{
    title = null;
    id = null;
    start = null;
    end = null;
    product = null;
    category = null;
    course = null;
    stock = 0;
    reservations = 0;
    duration = 0;
    
    constructor(id, title, start, end, product, category, course, stock, reservations){
        this.id = id;
        this.title = title;
        this.start = start;
        this.end = end;
        this.product = new Product(product.ID, product.title, category, product.strategy, product.variations);
        this.category = category;
        this.course = course;
        this.stock = parseInt(stock) || 0;
        this.reservations = parseInt(reservations) || 0;
        this.duration = moment(start, 'YYYY-MM-DD').set({hour:0, minute:0, second:0, millisecond: 0}).businessDiff(moment(end, 'YYYY-MM-DD').set({hour:0, minute:0, second:0, millisecond: 0})) + 1; //Li sumem 1 per incloure les dates
    }
}

export default Period;